enum OrderProductCode {
    CAMPAIGN = 'CAMPAIGN',
}

export default OrderProductCode;
